import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_BREAKPOINTS, CONTAINER_MAX } from '@/constants/breakpoints';
import { flexCenterAligned } from '@/styles/common';

export const Wrapper = styled.div`
  position: relative;
`;

export const Trigger = styled.button`
  all: unset;
  cursor: pointer;
  ${flexCenterAligned};
  gap: 4px;
  color: var(--textAndLabels-main);
`;

export const Arrow = styled.span<{ $isOpen: boolean }>`
  ${flexCenterAligned};
  transition: transform 0.2s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: -21px;

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    top: calc(100% + 27px);
  }

  @media (min-width: ${CONTAINER_BREAKPOINTS.tablet}) and (max-width: ${CONTAINER_MAX.tabletL}) {
    top: calc(100% + 36px);
  }
  background: var(--bg-main);
  border-radius: 28px;
  box-shadow: 0 17px 34px 0 rgba(151, 151, 151, 0.08);
  z-index: 5;
  min-width: 160px;
  padding: 10px 5px;
`;

export const Option = styled.button<{ $isSelected: boolean }>`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  padding: 0 15px;
  box-sizing: border-box;
  border-radius: 28px;
  transition: background 0.2s ease;
  color: var(--textAndLabels-main);
  background: ${({ $isSelected }) =>
    $isSelected ? 'var(--bg-secondary)' : 'transparent'};

  &:hover {
    background: var(--bg-secondary);
  }
`;

export const OptionLabel = styled(Typography).attrs({ variant: 'title4' })``;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 4;
`;
